<template>
  <div class="left-panel fixed">
    <div class="header-logo">
      <router-link :to="{ path: '/newsfeed' }">
        <img
          src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1662384370794.svg"
          alt="Home"
        >
      </router-link>
    </div>
    <div class="left-panel-inner">
      <ul class="pa-0">
        <div
          v-for="(menu) in menuList"
          :key="menu.id"
        >
          <li
            :class="menu.class1"
            @click="setActiveId(menu)"
          >
            <i :class="menu.class3" />
            <router-link :class="menu.class2" :to="{ path: menu.path }">
              <i :class="menu.icon" />
              {{menu.name}}
            </router-link>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftBar",
  data() {
    return {
      previousActiveId: 1,
      menuList: [
        {
          id: 1,
          name: "Media",
          icon: "icon news-feed-icon",
          path: "/newsfeed",
          class1: "active",
          class2: "active-bg",
          class3: "active-pipe",
        },
        // {
        //   id: 2,
        //   name: "Products",
        //   icactiveon: "icon product-icon",
        //   path: "/products",
        //   class1: "",
        //   class2: ""
        // },
        {
          id: 2,
          name: "Find Doctor",
          icon: "icon search-icon",
          path: "/findDoctor",
          class1: "",
          class2: "",
          class3: "",
        },
        {
          id: 3,
          name: "Bookings",
          icon: "icon schedule-icon",
          path: "/appointment/list",
          class1: "",
          class2: "",
          class3: "",
        },
        // {
        //   id: 4,
        //   name: "Profile",
        //   icon: "icon profile-icon",
        //   path: "/profile",
        //   class1: "",
        //   class2: "",
        // },
      ],
    };
  },
  created() {
    this.$bus.$on("setActiveId", (data) => {
      this.setActiveId(data);
    });
  },
  watch: {
    "$route.meta.module": function(module) {
      const isPath = element => element.name === module;
      const index = this.menuList.findIndex(isPath);
      const menuItem = this.menuList[index];
      this.setActiveId(menuItem);
    }
  },
  methods: {
    setActiveId(menu) {
      if (typeof menu === 'undefined') {
        this.menuList.forEach((item) => {
          item.class1 = '';
          item.class2 = '';
          item.class3 = '';
        });
        this.menuList[0].class1 = 'active';
        return;
      }
      if (
        this.previousActiveId === 'undefined'
        && this.previousActiveId === menu.id
      ) { return; }

      this.menuList.find(item => item.id === this.previousActiveId).class1 = '';
      this.menuList.find(item => item.id === this.previousActiveId).class2 = '';
      this.menuList.find(item => item.id === this.previousActiveId).class3 = '';

      this.menuList.find(item => item.id === menu.id).class1 = 'active';
      this.menuList.find(item => item.id === menu.id).class2 = 'active-bg';
      this.menuList.find(item => item.id === menu.id).class3 = 'active-pipe';

      this.menuList.find(item => item.id !== menu.id).class1 = '';
      this.menuList.find(item => item.id !== menu.id).class2 = '';
      this.menuList.find(item => item.id !== menu.id).class3 = '';
      this.previousActiveId = menu.id;
    },

  }
};
</script>
<style lang="scss" scoped>
.fixed {
  position: fixed;
  z-index: 100;
}
.header-logo {
  position: absolute;
  width: 72px;
  height: 27px;
  left: 12px;
  top: 32px;
}
.left-panel-inner a {
  display: inline-grid !important;
  text-align: center !important;
  color: #2f4c67 !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.25px;
  width: 95px;
}
.left-panel-inner a.active-bg {
  color: #122d4f !important;
}
</style>
